import {Component, OnInit, HostListener} from '@angular/core';
import {MultistepsService} from '@app/modules/applicant/base';
import {
  SessionService,
  StepsIdEnum,
  RequestTypesEnum,
  LookupsService,
  BannerEnum,
  ConstantsService
} from '@app/base/core';
import {FormGroup} from '@angular/forms';
import {CanComponentDeactivate} from '@app/base/shared';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {DaterangepickerConfig} from 'ng2-daterangepicker';
import {AlertService} from '@app/base/alerts/alert.service';

@Component({
  selector: 'app-premise',
  templateUrl: './premise.component.html',
  styleUrls: ['./premise.component.css']
})
export class PremiseComponent implements OnInit, CanComponentDeactivate {
  form: FormGroup;
  typeForm: FormGroup;
  alertMsg: any = [];
  stepsIdEnum: typeof StepsIdEnum = StepsIdEnum;
  requestTypeEnum: typeof RequestTypesEnum = RequestTypesEnum;

  @HostListener('window:beforeunload', ['$event']) onBeforeUnload(event) {
    event.preventDefault();
    // Specially for chrome...
    event.returnValue = this.constantSvc.changes;
  }

  constructor(
      public wizardSvc: MultistepsService, public lookupSvc: LookupsService,
      public sessionSvc: SessionService, public alertService: AlertService,
      private daterangepickerOptions: DaterangepickerConfig,
      public constantSvc: ConstantsService
  ) {
    this.daterangepickerOptions.skipCSS = true;
    this.wizardSvc.syncActiveStep(StepsIdEnum.PREMISE);
  }

  ngOnInit() {
    // Loads common Lookups
    const subscribe = this.lookupSvc.commonLookupsLoaded$.subscribe(val => {
      if (subscribe && val) {
        subscribe.unsubscribe();
      }

      this.typeForm = this.wizardSvc.getStepById(this.stepsIdEnum.TYPE).form;

      // TODO: DSS: rewrite due to question16 being undefined on residential flows - BT 3/6/24
      // loading Banner message
      if (this.typeForm.controls !== undefined && this.typeForm.controls['question16']) {
        const isCommercial = this.typeForm.controls['question16'].value || '';

        if (val && (isCommercial.toLowerCase() === this.requestTypeEnum.Commercial.toLowerCase()
            || isCommercial.toLowerCase() === this.requestTypeEnum.Industrial.toLowerCase())) {

          this.alertMsg = (this.lookupSvc.bannerMessages.find(x => x.itemName === 'Premise Details Business'
          ));
        } else if (val && (isCommercial.toLowerCase().contains(this.requestTypeEnum.MixedUse.toLowerCase()))) {
          this.alertMsg = (this.lookupSvc.bannerMessages.find(x => x.itemName === 'Premise Details Mixed'
          ));
        } else {
          this.alertMsg = (this.lookupSvc.bannerMessages.find(x => x.itemName === 'Premise Details'));
        }
      }
      this.alertService.info(this.alertMsg.message);
    });
    this.form = this.wizardSvc.getStepById(this.stepsIdEnum.PREMISE).form;
  }

  next() {
    this.wizardSvc.nextStep();
  } // Navigates to next page

  back() {
    this.wizardSvc.previousStep();
  } // Navigates to previous page

  canDeactivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot, nextState:
      RouterStateSnapshot) {
    return this.wizardSvc.canDeactivateStep(route, state, nextState);
  }
}
